// Widget Scripts
import headerButtons from './js/widgets/0-headerButtons.js';
import mainSlideshow from './js/widgets/1-mainSlideshow.js';
import autoEventFeed from './js/widgets/2-autoEventFeed.js';
import customCards from './js/widgets/0-customCards.js';
import seoSection from './js/widgets/4-seo-section/index.js';
import statsWidget from './js/widgets/5-statsWidget.js';
import sponsorsFeature from './js/widgets/7-sponsors/index.js';
import socialSection from './js/widgets/8-social-section/index.js';

// Custom Theme Scripts
import './js/localjs.js';

// Initialize Homepage Widgets
$(document).ready(function () {
  headerButtons('ticketBtn', typeof ticketBtnOpts === 'undefined' ? null : ticketBtnOpts);
  headerButtons('donateBtn', typeof donateBtnOpts === 'undefined' ? null : donateBtnOpts, 'isAlt');

  if (globalThis.location.pathname === '/') {
    mainSlideshow();
    autoEventFeed();
    customCards();
    customCards('mainCards', typeof mainCardsOpts === 'undefined' ? null : mainCardsOpts, 8);
    seoSection();
    statsWidget();
    customCards('moreCards', typeof moreCardsOpts === 'undefined' ? null : moreCardsOpts, 12);
    sponsorsFeature();
    socialSection();
  }
});
